module.exports = __webpack_public_path__ + "img/samsung_basic.abed41e.svg";